import { OktaAuth } from '@okta/okta-auth-js'
import { oktaAuthConfig } from '../okta_config'
const authClient = new OktaAuth(oktaAuthConfig)

export class Requests {

  static async request({url, method, payload, headers, parse, shouldThrow = false}) {
    let options
    if (payload !== null){
      options = {
        method,
        headers,
        body: JSON.stringify(payload)
      }
    } else {
      options =  {
        method,
        headers
      }
    }
    try {
      const res = await fetch(url, options)
      if (!res.ok && shouldThrow) {
        const errorBody = await res.json()
        throw errorBody
      }
      return parse ? await res.json() : res
    } catch (error) {
      console.error(`ERROR: Unable to fetch from endpoint ${url}\nError Message: ${error}`)
      if (shouldThrow) {
        throw error
      }
      return
    }
  }

  static async basicRequest(url, method, payload, headers){ 
    return await this.request({url, method, payload, headers, parse: true})
  }

  static async jsonRequest(url, method, payload){
    const headers = {
      'content-type': 'application/json'
    }
    return await this.request({url, method, payload, headers, parse: true})
  }

  static async authRequest(url, method, payload, shouldThrow = false){
    const accessTokenInfo = await authClient.tokenManager.get('accessToken')
    const accessToken = accessTokenInfo.accessToken
    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    }
    return await this.request({url, method, payload, headers, parse: true, shouldThrow})
  }

}
